import type { EnrichedLeadsSearchRow, LeadsSearchDetailsRowList, LeadsSearchRow } from "../types";

import { getLeadDomainFromRow } from "./rows";

export function enrichRowsWithDetailedData<R extends LeadsSearchRow>(
    rows: readonly R[],
    detailedResults: LeadsSearchDetailsRowList<R> | undefined,
): readonly EnrichedLeadsSearchRow[] {
    if (!rows.length || !detailedResults || Object.keys(detailedResults).length === 0) {
        return rows;
    }

    return rows.map((row) => {
        const domain = getLeadDomainFromRow(row);
        const detailedData = detailedResults[domain];

        return detailedData ? { ...row, detailedData: detailedData } : row;
    });
}
